/** @jsx jsx */
import { jsx, css } from '@emotion/react'
import { Fragment, h } from 'preact';
import { useState } from 'preact/hooks';
import { getContext } from '@searchspring/snap-toolbox';
import classnames from 'classnames';

// CSS
import '../../Result/result.css';
import '../../Result/cart-upsell.css';

export function CartUpsellProductCard({ cardProps: { parentProps, styling, parentSubProps } }) {
	// Destructure relevant data from parent component props
	const { result, className, layout, controller } = parentProps;

  const promptSelection = window.variantStrings.promptSelection;
  const hoverImage = result?.attributes?.ss_image_hover;
  const currencySymbol = window.Resources.shopCurrencySymbol;

  //States
  //Variant id once selected
  const [selectedVariantId, setSelectedVariantId] = useState(promptSelection);
  const [variantPrice, setVariantPrice] = useState(0);

  //Parse variants string returned from SS
  const variantsObject = Array.from(JSON.parse(result?.attributes?.variants));

	const context = getContext(['region']);
	const core = result?.mappings?.core;

	//Handle CA french product URL
	let productUrl = core.url;
	if (window.Shopify.locale == 'fr') {
		productUrl = `/fr${productUrl}`;
	}

	return (
		<article {...styling} className={classnames('ss__result--cart-drawer-card', typeof hoverImage != 'undefined' && 'ss__result__hover', `ss__result--${layout}`, className)} data-href={productUrl}
    
    onClick={(e) => {
      //Only click thru to the PDP if the user clicks something that's not the ATC or Variant selector
      const eventTarget = e.target;

      if(
        !eventTarget.classList.contains("cart-upsell-card__variant") &&
        !eventTarget.classList.contains("ss__results__form") &&
        !eventTarget.classList.contains("button")
      ){
        window.location.href = e.target.closest("[data-href]")?.dataset?.href;
      }
    }}>
      <div className="cart-upsell-card__top-wrapper">
        <div className="cart-upsell-card__image-wrapper">
          <div {...styling} className={classnames('cart-upsell-card__image')}>
           <img
              id={`ProductImage-${result.id}`}
              alt={core.name}
              className="cart-upsell-card__product-image"
              data-sizes="auto"
              data-image
              src={core.imageUrl}
            />
          </div>
        </div>
        <div className="cart-upsell-card__details">
          <div className="cart-upsell-card__title body-medium">
            {core.name}
          </div>

          <form method="post" action="/cart/add" className="ss__results__form">

            <select
              className={`cart-upsell-card__variant ${variantsObject?.length <= 1 ? 'cart-upsell-card__variant--hidden' : ''}`}
              onChange={e => {

                //On variant select, update id state
                setSelectedVariantId(e.target.value);

                //Find variant selected and grab it's price too
                const index = e.target.selectedIndex;
                const optionElement = e.target.childNodes[index];
                const price = optionElement.dataset.variantPrice;

                //Update price state
                setVariantPrice(price);
              }}
            >
              {variantsObject?.length > 1 &&
                <>
                  {/* First variant always Select Size */}
                  <option disabled="disabled" selected="selected">{promptSelection}</option>
                </>
              }

              {/* Then, loop through real variants */}
              {variantsObject.map((variant) => (
                <option
                value={variant.id} 
                disabled={variant?.inventory_quantity <= 0 ? "disabled" : false}
                data-variant-price={variant?.price}
                >
                  {variant.title}
                </option>
              ))}
            </select>

            {/* Hidden form inputs */}
            {/* Variant id storage, with state */}
            <input type="hidden" name="id" value={`${variantsObject?.length <= 1 ? variantsObject[0]?.id : selectedVariantId}`} />

            {/* Quantity always set to 1 */}
            <input className="hidden" min="1" type="number" id="quantity" name="quantity" value="1"/>

            {/*
              If there are no variants (aka only 1 variant in Shopify)
              then show a different button, not disabled
            */}
            {variantsObject?.length == 1 &&
              <button
                className="button button--primary-black"
                type="submit"
              >

                {window.Resources.searchspring.productCards.addToCart}{"\u00a0"}
                
                {context.region == 'us' && variantPrice !== 0 && (
                  <>
                    - {currencySymbol}{variantPrice}
                  </>
                )}

                {context.region == 'ca' && variantPrice !== 0 && (
                  <>
                    - {currencySymbol}{variantPrice}
                  </>
                )}

                {context.region == 'uk' && variantPrice !== 0 && window.Resources.marketHandle == 'uk' && (
                  <>
                    - {currencySymbol}{variantPrice}
                  </>
                )}
              </button>
            }
            
            {/* If there are variants, show different ATC button, already disabled */}
            {variantsObject?.length > 1 &&
              <button
                className="button button--primary-black"
                type="submit"
                disabled={selectedVariantId == promptSelection ? "disabled" : false}
              >

                {window.Resources.searchspring.productCards.addToCart}{"\u00a0"}
                
                {context.region == 'us' && variantPrice !== 0 && (
                  <>
                    - {currencySymbol}{variantPrice}
                  </>
                )}

                {context.region == 'ca' && variantPrice !== 0 && (
                  <>
                    - {currencySymbol}{variantPrice}
                  </>
                )}

                {context.region == 'uk' && variantPrice !== 0 && window.Resources.marketHandle == 'uk' && (
                  <>
                    - {currencySymbol}{variantPrice}
                  </>
                )}
              </button>
            }
          </form>
        </div>
      </div>
		</article>
	);
}
